/**
 * @flow
 * @relayHash 59a77f73ff342bde77c1848559fe2b98
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type testEmailInput = {|
  clientMutationId?: ?string,
  id: string,
  recipients: string,
  subject: string,
  bodyHtml: string,
  bodyPlain?: ?string,
  from?: ?string,
  cc?: ?string,
  bcc?: ?string,
  reply_to?: ?string,
  attachments?: ?string,
  preheader?: ?string,
  prefix?: ?string,
  comment?: ?string,
|};
export type testEmailMutationVariables = {|
  input: testEmailInput
|};
export type testEmailMutationResponse = {|
  +testEmail: ?{|
    +hyblast: ?{|
      +id: string
    |}
  |}
|};
export type testEmailMutation = {|
  variables: testEmailMutationVariables,
  response: testEmailMutationResponse,
|};
*/


/*
mutation testEmailMutation(
  $input: testEmailInput!
) {
  testEmail(input: $input) {
    hyblast {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "testEmailInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "testEmail",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "testEmailPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyblast",
        "storageKey": null,
        "args": null,
        "concreteType": "Hyblast",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "testEmailMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "testEmailMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "testEmailMutation",
    "id": null,
    "text": "mutation testEmailMutation(\n  $input: testEmailInput!\n) {\n  testEmail(input: $input) {\n    hyblast {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '598e887cb71508bdaf093f151513c8e0';
module.exports = node;
